// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-add"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 6.5L8 3L3 6.5V19L8 16M16 6.5L21 4V10M16 6.5V10M8 16V3.5M8 16L9.99798 16.999","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18 13V17M18 17V21M18 17H14M18 17H22","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapAddIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-add',
    ref,
    icon: element,
  },
));

MapAddIcon.displayName = 'MapAddIcon';

export default MapAddIcon;
